/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeflyerliveroomname4Inputs */

const en_placeflyerliveroomname4 = /** @type {(inputs: Placeflyerliveroomname4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Room`)
};

const de_placeflyerliveroomname4 = /** @type {(inputs: Placeflyerliveroomname4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Room`)
};

/**
* | output |
* | --- |
* | "Live Room" |
*
* @param {Placeflyerliveroomname4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyerliveroomname4 = /** @type {((inputs?: Placeflyerliveroomname4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyerliveroomname4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyerliveroomname4(inputs)
	return de_placeflyerliveroomname4(inputs)
});
export { placeflyerliveroomname4 as "placeFlyerLiveRoomName" }